import React, { useState, useEffect, createContext } from "react";
// import { useSessionStorage } from "@uidotdev/usehooks";

const MenuContext = createContext();

export const MenuContextProvider = (props) => {
    const [menuItemsInternal, setMenuItems] = useState({});

    const fetchHtml = ( async () => {
        // const apiResponse = await fetch(`/staticData/NavigationConfig.json`);
        // const jsonApiResponse = await apiResponse.json();
        // setMenuItems(jsonApiResponse)
 
    })

    useEffect(() => {
        // fetchHtml();
        let menuStructure = '';
        // console.log(`MenuContextProvider.useEffect`);
        try{
            // console.log(`MenuContextProvider.useEffect intiating`);
            menuStructure = sessionStorage.getItem('menuStructure');
            // console.log(`MenuContextProvider.useEffect menuStructure retrieving from sessionStorage: ${menuStructure}`);
            if(menuStructure === null || menuStructure === ""){
                // console.log(`MenuContextProvider.useEffect inside if`);
                fetch(`/staticData/NavigationConfig.json`)
                .then((res) => res.json())
                .then((data) => {
                    // console.log(`MenuContextProvider.useEffect data is: ${data}`);
                    setMenuItems(data);
                    sessionStorage.setItem('menuStructure', JSON.stringify(data));
                });
            }else {
                // console.log(`In else, getting config file`);
                let tempMenuStructure = "";
                fetch(`/staticData/NavigationConfig.json`)
                .then((res) => res.json())
                .then((data) => {
                    // console.log(`MenuContextProvider.useEffect data is: ${data}`);
                    // setMenuItems(data);
                    // sessionStorage.setItem('menuStructure', JSON.stringify(data));
                    tempMenuStructure = JSON.stringify(data);
                });
                if (JSON.stringify(menuStructure) !== tempMenuStructure)
                {
                    // console.log(`Current session is not the same as file.`);
                    // console.log(`menuStructure: ${JSON.stringify(menuStructure)}`);
                    // console.log(`tempMenuStructure: ${tempMenuStructure}`);
                    setMenuItems(JSON.parse(menuStructure));
                    sessionStorage.setItem('menuStructure', tempMenuStructure);
                }
                // console.log(`MenuContextProvider.useEffect in else`);
                // console.log(`MenuContextProvider.useEffect menuStructure is: ${menuStructure}`);
                // console.log(`MenuContextProvider.useEffect JSON.stringify(menuStructure) is: ${JSON.stringify(menuStructure)}`);
                // setMenuItems(JSON.parse(menuStructure));
            }
        }catch(e) {
            console.log("Error: ", e)
        }
        // console.log(JSON.parse(menuStructure);
        
    },[])

    return (
        <MenuContext.Provider value={menuItemsInternal}>
            {props.children}
        </MenuContext.Provider>
        );

}

export default MenuContext;